import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { BankAccountSidePanel } from "../BankAccount/BankAccountSidePanel";

interface Props {
  bankAccount: server.dto.BankAccountSmall
}

export const BankAccountDetails = ({ bankAccount }: Props) => {
  return <BankAccountSidePanel
    bankAccountId={bankAccount.bankAccountId}
    trigger={<div className="side-panel-list-item hoverable flex-column">
      <SmallDetails
        label={bankAccount.title}
        subLabel={bankAccount.beneficiaryName}
      />
    </div>}
  />
}